import React from "react";

import {
  Box,
  Card,
  CardContent,
  Typography,
} from "@mui/material";

import {
  Cell,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

function StatusChart({ data = [] }) {
  const chartData = data.map((item) => ({
    name: item.status,
    value: item.count,
  }));

  const COLORS = {
    Open: "#f59e0b",
    Assigned: "#2563eb",
    "In Progress": "#9333ea",
    Resolved: "#16a34a",
    Closed: "#64748b",
  };

  const total = chartData.reduce((sum, item) => sum + item.value, 0);

  return (
    <Card
      sx={{
        width: "100%",
        height: "100%",
        minHeight: 380,
        display: "flex",
        borderRadius: 3,
        bgcolor: "background.paper",
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <CardContent
        sx={{
          p: 2.5,
          display: "flex",
          flexDirection: "column",
          flex: 1,
        }}
      >
        <Typography variant="h6" fontWeight={700} color="text.primary" mb={2}>
          Ticket Status Distribution
        </Typography>

        <Box
          sx={{
            height: 250,
            flexShrink: 0,
          }}
          position="relative"
        >
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="45%"
                innerRadius={65}
                outerRadius={100}
                paddingAngle={4}
                dataKey="value"
              >
                {chartData.map((item, index) => (
                  <Cell key={`status-cell-${index}`} fill={COLORS[item.name] || "#94a3b8"} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>

          <Box
            sx={{
              position: "absolute",
              top: "43%",
              left: "50%",
              transform: "translate(-50%,-50%)",
              textAlign: "center",
            }}
          >
            <Typography fontSize={30} fontWeight={700}>
              {total}
            </Typography>
            <Typography fontSize={12} color="text.secondary">
              Total
            </Typography>
          </Box>
        </Box>

        <Box display="flex" justifyContent="center" gap={2} flexWrap="wrap">
          {Object.entries(COLORS).map(([name, color]) => (
            <Box key={name} display="flex" alignItems="center" gap={0.7}>
              <Box sx={{ width: 10, height: 10, borderRadius: "50%", bgcolor: color }} />
              <Typography fontSize={12} color="#475569">
                {name}
              </Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}

export default StatusChart;
